/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Hatchery } from '../../models/hatchery';

export interface AddHatchery$Params {
      body: Hatchery
}

export function addHatchery(http: HttpClient, rootUrl: string, params: AddHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
  const rb = new RequestBuilder(rootUrl, addHatchery.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Hatchery>;
    })
  );
}

addHatchery.PATH = '/api/hatchery';
